var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('va-line-field',{attrs:{"polylines":_vm.polylines,"zoom":11,"multiple":"","height":"500px"}}),_c('base-material-card',{attrs:{"icon":_vm.resource.icon,"title":_vm.title}},[_c('va-list',{ref:"list",attrs:{"filters":_vm.filters,"include":[
        'watercourse_type_entity',
        'livestock_access_entity',
        'irrigation_entity',
      ]},on:{"update:listState":_vm.onListStateUpdate},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('add-watercourses-button',{on:{"added":_vm.onAdded}})]},proxy:true}])},[_c('va-data-table',{attrs:{"fields":_vm.fields,"disable-clone":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }